import { FeatureAppLoader } from '@feature-hub/react';
import {
  Container,
  IntegratorRoot,
  Layout,
  ThemeProvider,
} from '@volkswagen-onehub/components-core';
import { History } from 'history';
import React from 'react';
import {
  Content,
  FaContentServiceV1,
} from '@volkswagen-onehub/fa-content-service';
import { appsCommonsJS, appsUMD } from './app-constants';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';
import {
  contentFeatureAppMap,
  getConfigsFeatureApp,
} from './feature-app-helpers';
import { HelmetUpdater } from './helmet-updater';
import { PageInfoServiceV1 } from '@volkswagen-onehub/page-info-service';

export interface IntegratorProps extends ModelOverviewIntegratorOptions {
  readonly history: History;
  readonly pageInfoService: PageInfoServiceV1;
}

export function Integrator({
  baseUrl,
  history,
  ssr,
  featureAppName = 'default',
  pageInfoService,
  ...props
}: IntegratorProps): JSX.Element {
  const featureAppConfig = getConfigsFeatureApp({
    ...props,
    featureAppName,
  });

  console.log('featureAppConfig:', featureAppConfig);
  console.log('baseUrl:', baseUrl);
  console.log('ssr:', ssr);
  console.log('src:', appsUMD[featureAppName]);
  console.log('serverSrc:', ssr ? appsCommonsJS[featureAppName] : undefined);
  console.log('pageInfoService:', pageInfoService);

  return (
    <IntegratorRoot>
      <ThemeProvider>
        <Layout appearance={{}} allowOverflowingContent>
          <FeatureAppLoader
            featureAppId="breadcrumbs"
              baseUrl={baseUrl}
              src="/assets/breadcrumbs-feature-app/breadcrumbs-feature-app.js"
              config={{
                breadcrumbConsumerIds: [
                  'integrator',
                  'quick-start-guide',
              ],
            }}
          />
          <Container wrap='always' padding={{}}>
            <FeatureAppLoader
              featureAppId='quick-start-guide'
              baseUrl={baseUrl}
              src={appsUMD[featureAppName]}
              serverSrc={ssr ? appsCommonsJS[featureAppName] : undefined}
              config={featureAppConfig}
              beforeCreate={({ featureServices }) => {
                const content: Content = contentFeatureAppMap[featureAppName];

                if (content) {
                  (
                    featureServices['fa-content-service'] as FaContentServiceV1
                  ).content = content;
                }
              }}
            />
          </Container>
        </Layout>
        <HelmetUpdater pageInfoService={pageInfoService} />
      </ThemeProvider>
    </IntegratorRoot>
  );
}
